import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar-sticky" }
const _hoisted_3 = { class: "page-bar page-bar-toggles-wrap" }
const _hoisted_4 = { class: "page-bar-toggles" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_7 = { class: "pf-search" }
const _hoisted_8 = {
  key: 1,
  class: "full-table"
}
const _hoisted_9 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_10 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_11 = {
  key: 2,
  style: {"text-align":"center"}
}
const _hoisted_12 = {
  key: 3,
  style: {"text-align":"center"}
}
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { style: {"text-align":"center"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "full-table"
}
const _hoisted_17 = {
  key: 3,
  class: "full-table"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 4,
  class: "full-table"
}
const _hoisted_22 = { class: "table-labels" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 0,
  style: {"text-align":"center","white-space":"nowrap"}
}
const _hoisted_26 = {
  key: 0,
  class: "na-forge-done"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 5,
  class: "full-table"
}
const _hoisted_29 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_sign_off_cells = _resolveComponent("sign-off-cells")!
  const _component_forge_suggestion_draft = _resolveComponent("forge-suggestion-draft")!
  const _component_process_suggestion_form = _resolveComponent("process-suggestion-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "page-bar" }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", { class: "page-bar-sub" }, "Foundations"),
          _createElementVNode("div", { class: "page-bar-main" }, "Review")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              onClick: ($event: any) => (_ctx.selectType(type.type)),
              class: _normalizeClass(_ctx.selectedType == type.type ? 'page-bar-toggle-s' : '')
            }, [
              _createTextVNode(_toDisplayString(type.type), 1),
              _createElementVNode("span", null, _toDisplayString(type.count), 1)
            ], 10, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "11",
                  cy: "11",
                  r: "7"
                }),
                _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQ) = $event)),
                placeholder: "Search",
                "aria-label": "Search",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
              }, null, 544), [
                [_vModelText, _ctx.searchQ]
              ])
            ]),
            (_ctx.selectedType == 'Process Suggestions')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = () => { _ctx.showAddSuggestion = true }),
                    class: "add-btn"
                  }, "Add")
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isNodeType)
        ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              _cache[17] || (_cache[17] = _createElementVNode("tr", { class: "table-labels" }, [
                _createElementVNode("td", null, "Name"),
                _createElementVNode("td", null, "Last Modified"),
                _createElementVNode("td", null, "Modifed By"),
                _createElementVNode("td", null, "Type"),
                _createElementVNode("td", null, "Process Owner"),
                _createElementVNode("td"),
                _createElementVNode("td")
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("tr", { style: {"height":"0","padding":"0"} }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                      to: '/playbook/' + node.Slug
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(node.Name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(node.LastModifiedString), 1),
                  _createElementVNode("td", null, _toDisplayString(node.LastUpdatedBy), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$store.state.playbookNodeTypeMap[node.Type]), 1),
                  _createElementVNode("td", null, _toDisplayString(node.ProcessOwnerNames), 1),
                  (node.Type == 'PROCESS')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                        _createVNode(_component_router_link, {
                          to: '/edit-process/' + node.Slug
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("Edit", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : (node.Type == 'TIMELINE')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                          _createVNode(_component_router_link, {
                            to: '/edit-timeline/' + node.Slug
                          }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("Edit", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : (node.Type == 'SHEET')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                            _createVNode(_component_router_link, {
                              to: '/edit-sheet/' + node.Slug
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("Edit", -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : (node.Type == 'CHECKLIST')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                              _createVNode(_component_router_link, {
                                to: '/edit-checklist/' + node.Slug
                              }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode("Edit", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_13)),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.deleteNode(node)), ["prevent"])
                    }, "Delete", 8, _hoisted_15)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_ctx.selectedType == 'Needs Review')
          ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
              _createElementVNode("tbody", null, [
                _cache[19] || (_cache[19] = _createElementVNode("tr", { class: "table-labels" }, [
                  _createElementVNode("td", null, "Name"),
                  _createElementVNode("td", null, "Modifed By"),
                  _createElementVNode("td", null, "Type"),
                  _createElementVNode("td", null, "Process Owner"),
                  _createElementVNode("td", null, "Age")
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewNodes, (node, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: '/playbook/' + node.Slug
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(node.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(node.LastUpdatedBy), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$store.state.playbookNodeTypeMap[node.Type]), 1),
                    _createElementVNode("td", null, _toDisplayString(node.ProcessOwnerNames), 1),
                    _createElementVNode("td", null, _toDisplayString(node.AgeString), 1)
                  ]))
                }), 128))
              ])
            ]))
          : (_ctx.selectedType == 'Sign Offs')
            ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                _createElementVNode("tbody", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("tr", { class: "table-labels" }, [
                    _createElementVNode("td", null, "Date"),
                    _createElementVNode("td", null, "Process"),
                    _createElementVNode("td", null, "Signature"),
                    _createElementVNode("td", null, "Sheet Column")
                  ], -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signOffs, (so, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, _toDisplayString(so.DateDisplay), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: '/playbook/' + so.Slug
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(so.NodeName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (so.SignatureData)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (_ctx.showSignOffCells(so)), ["prevent"])
                            }, _toDisplayString(so.Signature), 9, _hoisted_18))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(so.Signature), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (so.Seat)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (_ctx.showSignOffCells(so)), ["prevent"])
                            }, _toDisplayString(so.SeatName), 9, _hoisted_20))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : (_ctx.selectedType == 'Process Suggestions')
              ? (_openBlock(), _createElementBlock("table", _hoisted_21, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_22, [
                      _cache[23] || (_cache[23] = _createElementVNode("td", null, "Date", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("td", null, "User", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("td", null, "Suggestion", -1)),
                      (_ctx.canForge)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_23))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("tr", { style: {"height":"0","padding":"0"} }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (s, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", null, _toDisplayString(s.DateDisplay), 1),
                        _createElementVNode("td", null, _toDisplayString(s.User), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            innerHTML: s.Text
                          }, null, 8, _hoisted_24)
                        ]),
                        (_ctx.canForge)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                              (s.ForgeStatus == 'saved')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Saved as draft"))
                                : (s.ID)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (_ctx.forgeSuggestion = s), ["prevent"])
                                    }, _toDisplayString(s.ForgeStatus == 'drafted' ? 'Open the Forge draft' : 'Draft with the Forge'), 9, _hoisted_27))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_ctx.selectedType == 'Comments')
                ? (_openBlock(), _createElementBlock("table", _hoisted_28, [
                    _createElementVNode("tbody", null, [
                      _cache[27] || (_cache[27] = _createElementVNode("tr", { class: "table-labels" }, [
                        _createElementVNode("td", null, "Date"),
                        _createElementVNode("td", null, "Process"),
                        _createElementVNode("td", null, "User"),
                        _createElementVNode("td", null, "Comment")
                      ], -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (c, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          _createElementVNode("td", null, _toDisplayString(c.DateDisplay), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: '/playbook/' + c.Slug
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(c.Name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(c.User), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", {
                              innerHTML: c.Comment
                            }, null, 8, _hoisted_29)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
    ], 2),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _ctx.deleteNodeConfirm,
          onCancel: _cache[3] || (_cache[3] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to PERMANENTLY DELETE this process?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showSignOff)
      ? (_openBlock(), _createBlock(_component_sign_off_cells, {
          key: 1,
          signOff: _ctx.signOffToShow,
          onClose: _cache[4] || (_cache[4] = () => { _ctx.showSignOff = false })
        }, null, 8, ["signOff"]))
      : _createCommentVNode("", true),
    (_ctx.forgeSuggestion)
      ? (_openBlock(), _createBlock(_component_forge_suggestion_draft, {
          key: 2,
          suggestion: { ID: _ctx.forgeSuggestion.ID, ForgeStatus: _ctx.forgeSuggestion.ForgeStatus },
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.forgeSuggestion = null)),
          onDrafted: _cache[6] || (_cache[6] = () => { _ctx.forgeSuggestion.ForgeStatus = 'drafted'; }),
          onSaved: _cache[7] || (_cache[7] = () => { _ctx.forgeSuggestion.ForgeStatus = 'saved'; _ctx.forgeSuggestion = null; }),
          onDismissed: _cache[8] || (_cache[8] = () => { _ctx.forgeSuggestion.ForgeStatus = 'dismissed'; _ctx.forgeSuggestion = null; })
        }, null, 8, ["suggestion"]))
      : _createCommentVNode("", true),
    (_ctx.showAddSuggestion)
      ? (_openBlock(), _createBlock(_component_process_suggestion_form, {
          key: 3,
          onClose: _cache[9] || (_cache[9] = async () => { _ctx.showAddSuggestion = false; await _ctx.getSuggestions(); _ctx.search(); })
        }))
      : _createCommentVNode("", true)
  ]))
}